import { DataBlockTypeDto } from '@lmt/shared-types';
import React from 'react';
import { DataBlockPreview } from '../../cases/components/blocks/DataBlockPreview';

import styles from './PatientVisits.module.scss';

export interface PatientDataBlocksProps {
  patientId: number;
  dataBlockType: DataBlockTypeDto;
}

export const PatientDataBlockPanel: React.FC<PatientDataBlocksProps> = (
  props,
) => {
  const { patientId, dataBlockType } = props;

  return (
    <div className={styles.container}>
      <div className={styles.data}>
        <DataBlockPreview
          type={'update_patient_block'}
          patientId={patientId}
          dataBlockTypeId={dataBlockType.id}
        />
      </div>
    </div>
  );
};
